import { publicHref } from '../lib/publicUrls';
import { Link } from 'react-router-dom';
import MediaTruthSurface from '../components/MediaTruthSurface';
import PhotoSlot, { photoKey } from '../components/PhotoSlots';
import { ServiceBreadcrumb, ServiceFacts } from '../components/ServiceHeader';
import './SchedulePages.css';

const destinations = [
  ['/schedule', 'All Classes'],
  ['/schedule/cardio', 'Cardio'],
  ['/schedule/mind-body', 'Mind-Body'],
  ['/schedule/weight-training', 'Weight Training'],
];

export const ScheduleNavigation = ({ current }) => (
  <nav className="dv-class-pages__navigation" aria-label="Class schedules">
    <div>{destinations.map(([path, label]) => (
      <Link key={path} to={publicHref(path)} aria-current={current === path ? 'page' : undefined}>{label}</Link>
    ))}</div>
  </nav>
);

export const ScheduleMedia = ({ media, src, asset, alt, caption }) => (
  <figure className="dv-class-pages__media">
    {media ? <MediaTruthSurface media={media} className="dv-class-pages__image" /> :
      <PhotoSlot className="dv-class-pages__image" id={`schedule-${asset}-${photoKey(alt)}`} label={alt || caption} />}

  </figure>
);

export const ScheduleHero = ({ title, children, media, scheduleId, facts,
  parent = { label: 'Schedule', href: '/schedule' }, secondary = { label: 'All Classes', href: '/schedule' } }) => (
  <section className="dv-class-pages__hero" aria-labelledby="class-page-title">
    <div className="dv-class-pages__hero-inner">
      <div className="dv-class-pages__hero-copy">
        <div className="dv-service-panel">
          <ServiceBreadcrumb parent={parent} current={title} />
          <h1 id="class-page-title" className="dv-size-heading dv-service-title">{title}</h1>
          {children}
          <div className="dv-service-actions">
            <a className="dv-button dv-button--light" href={publicHref(`#${scheduleId}`)}>View the Live Schedule</a>
            <Link className="dv-button dv-button--outline-light" to={publicHref(secondary.href)}>{secondary.label}</Link>
          </div>
        </div>
      </div>
      {media}
    </div>
    {facts && <ServiceFacts items={facts} />}
  </section>
);

export const ClassLedger = ({ classes }) => (
  <div className="dv-class-pages__ledger">
    {classes.map(([name, description], index) => (
      <article className="dv-class-pages__class" key={name}>
        <span className="dv-class-pages__index" aria-hidden="true">{String(index + 1).padStart(2, '0')}</span>
        <div><h3 className="dv-size-subheading text-2xl font-semibold">{name}</h3><p className="dv-size-body leading-relaxed">{description}</p></div>
      </article>
    ))}
  </div>
);
